import styled from 'styled-components'

export const TextWrapper = styled.div`
  max-width: 650px;
  font: var(--theme-typography-bodyL-regular);
`
